import { render, staticRenderFns } from "./OfficeSlider.vue?vue&type=template&id=00df9b46&scoped=true&"
import script from "./OfficeSlider.vue?vue&type=script&lang=js&"
export * from "./OfficeSlider.vue?vue&type=script&lang=js&"
import style0 from "./OfficeSlider.vue?vue&type=style&index=0&id=00df9b46&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00df9b46",
  null
  
)

export default component.exports